export default __webpack_public_path__ + "static/services-details1-a63d89e31171bbee3d76a610a08b2127.jpg";